import executionStepTranslations from "./executionStepTranslations";

const executionJobTranslations = {
  status: {
    pendingApproval: "Ausstehend",
    approved: "Freigegeben",
    running: "Läuft",
    completed: "Erfolgreich",
    failed: "Fehlgeschlagen",
    partiallyFailed: "Teilweise fehlgeschlagen",
    rejected: "Abgelehnt",
  },
  step: executionStepTranslations,
};

export default executionJobTranslations;
